import { Fragment, type ReactNode } from "react";

import { Navigate } from "react-router";
import type { TUserRoles } from "../app/app.constants";
import useAuth from "../hooks/useAuth";

interface AuthGuardProps {
  children: ReactNode;
  roles?: TUserRoles[];
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const { accessToken } = useAuth();

  // const hasValidRole = roles?.length
  //   ? roles.includes(role as TUserRoles)
  //   : true;
  // const isAuthenticated = Boolean(
  //   access_token && hasValidRole && keycloak.authenticated,
  // );

  // TODO: Enable auth guard
  if (!accessToken) {
    return <Navigate to="/login" />;
  }

  return <Fragment>{children}</Fragment>;
}
